import React from 'react';
import {View, StyleSheet, Image, TouchableOpacity} from 'react-native';
import {
    DrawerContentScrollView,
    DrawerItem
} from '@react-navigation/drawer';
import {
    Avatar,
    Title,
    Caption,
    Paragraph,
    Drawer,
    Text,
    TouchableRipple,
    Switch,
} from 'react-native-paper';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons.js';
import Ionicons from 'react-native-vector-icons/Ionicons.js';
import RootNavigator from './index';


export default function DrawerContent(props) {

    const logo = require("../assets/logo.png")

    return (
        <View style={{flex: 1}}>
            <DrawerContentScrollView {...props}>
                <View style={styles.drawerContent}>
                    <View style={styles.userInfoSection}>
                        <TouchableOpacity onPress={() => ({})}>
                            <Avatar.Image
                                source={{uri: logo}}
                                size={40}
                            />
                        </TouchableOpacity>
                    </View>

                    <Drawer.Section style={styles.drawerSection}>
                        <DrawerItem
                            icon= {({color, size}) => (
                                <Ionicons
                                    name="home"
                                    size={22}
                                    color={color}
                                />
                            )}
                            label={""}
                            activeTintColor={'white'}
                            inactiveTintColor={'gray'}
                            onPress={() => {props.navigation.navigate('Verify')} }
                        />
                        <DrawerItem
                            icon= {({color, size}) => (
                                <MaterialCommunityIcons
                                    name="view-dashboard"
                                    size={22}
                                    color={color}
                                />
                            )}
                            label={""}
                            activeTintColor={'gray'}
                            inactiveTintColor={'white'}
                            onPress={() => {props.navigation.navigate('Dashboard')} }
                        />
                        <DrawerItem
                            icon= {({color, size}) => (
                                <MaterialCommunityIcons
                                    name="google-analytics"
                                    size={22}
                                    color={color}
                                />
                            )}
                            label={""}
                            activeTintColor={'white'}
                            inactiveTintColor={'gray'}
                            onPress={() => {props.navigation.navigate('Analytics')} }
                        />
                        <DrawerItem
                            icon= {({color, size}) => (
                                <Ionicons
                                    name="settings"
                                    size={22}
                                    color={color}
                                />
                            )}
                            label={""}
                            activeTintColor={'white'}
                            inactiveTintColor={'gray'}
                            onPress={() => {props.navigation.navigate('Settings')} }
                        />
                    </Drawer.Section>
                </View>
            </DrawerContentScrollView>
            <Drawer.Section style={styles.bottomDrawerSection}>
                <DrawerItem
                    icon= {({color, size}) => (
                        <MaterialCommunityIcons
                            name="exit-to-app"
                            size={22}
                            color={color}
                        />
                    )}
                    label={""}
                    activeTintColor={'white'}
                    inactiveTintColor={'gray'}
                    onPress={() => alert('You are about to Sign out') }
                />
            </Drawer.Section>
        </View>
    );
};

const styles = StyleSheet.create({
    drawerContent: {
       flex: 1,
    },
    userInfoSection: {
        justifyContent: 'center',
        alignSelf: 'center',
        marginTop: 20,
    },
    drawerSection: {
        marginTop: 100,
        marginLeft: 3,
    },
    bottomDrawerSection: {
        marginBottom: 15,
    },
});